import type { Row } from './read-context';

export const PL_SOURCE_BROWSER = 'browser-frozen';
const isObj = (v: unknown): v is Row => v !== null && typeof v === 'object' && !Array.isArray(v);

export interface PlState { value: number | null; pending: boolean; source: 'browser-frozen' | 'server-legacy' | null; contract: string | null; statusShare: number | null }
/** computed.pl as the page holds it: the bare number, its provenance and the contract it was priced under (heal writes carry both). A
 *  missing / null / non-numeric slot is UNPRICED (never coerced to 0 — a genuine 0 is a number). */
export function plStateOf(row: Row | null | undefined): PlState {
    const computed = row && isObj(row.computed) ? row.computed : null;
    const pl = computed?.pl;
    const pending = !!(computed && computed.pl_pending);
    const none: PlState = { value: null, pending, source: null, contract: null, statusShare: null };
    if (pl === null || pl === undefined || pl === '' || pl === false) return none;
    let raw: unknown = pl;
    if (isObj(pl) || Array.isArray(pl)) { const r = pl as Row; raw = r[0] ?? r['0']; } // a legacy {0: n} shape still reads
    if (raw === null || raw === undefined || raw === '' || typeof raw === 'boolean') return none;
    const value = typeof raw === 'number' ? raw : (typeof raw === 'string' && raw.trim() !== '' ? Number(raw) : NaN);
    if (!Number.isFinite(value)) return none;
    // provenance lives in computed.pl_meta beside the bare number (live readers share these blobs and want a number)
    const meta = computed && isObj(computed.pl_meta) ? computed.pl_meta as Row : null;
    const source = meta && meta.source === PL_SOURCE_BROWSER ? 'browser-frozen' : 'server-legacy';
    return { value, pending, source, contract: meta && typeof meta.contract === 'string' ? meta.contract : null,
        statusShare: meta && typeof meta.status_share === 'number' ? meta.status_share : null };
}
